export class Country {
    name: string;
    code_num: string;
    code_string2: string;
    code_string3: string;
    continent_id: number;
}
